/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export const DATA_TASK_RECORDING_MIME_TYPES = ["video/webm;codecs=vp9,pcm","video/webm;codecs=vp8,opus","video/webm;codecs=vp8,pcm"] as const;
